export const assessmentDetailsStub = {
  id: "95981e84-8352-4193-a3bc-ac5c6420a013",
  name: "Tennr - (Internal)",
  description: null,
  assessmentLinkActiveDuration: {
    endTime: "2024-12-14T16:00",
    startTime: "2024-12-14T14:00",
  },
  allowedAttempts: 1,
  totalSubmissions: 12,
  totalCandidates: "12",
};

export const candidatesData = {
  assessments: [
    {
      id: "b6e8648e-e10c-4207-930b-78bc6485ca12",
      email: "mf4357452@gmail.com",
      hasSentEmail: true,
      createdAt: "2024-12-24 17:04:21",
      updatedAt: "2024-12-24T07:19:15.253Z",
      assessmentId: "4e42585f-80ef-4d4a-9b02-6cf41d5769fe",
      name: "Mohd Fazal",
      totalQuestionsAsked: null,
      totalCorrectAnswers: null,
      totalWrongAnswers: null,
      totalUnattemptedQuestions: null,
      scorePercentage: "81",
      timeTakenByStudentInSeconds: null,
      feedback:
        "The candidate demonstrated a solid understanding of various technical concepts, particularly in solving algorithmic problems related to graphs and patterns using DFS and stack. The candidate also effectively solved an abstract reasoning question, showing strong logical thinking skills. However, there were issues with SQL syntax and handling Flask API character limit validation.",
      weakAreas: ["SQL", "Flask API"],
      strongAreas: ["Graphs", "DFS", "Stack", "Abstract Reasoning"],
      gptFinalFeedback: null,
      assessmentStartedTime: "2024-12-24T11:38:26.685Z",
      assessmentCompletedTime: "2024-12-24T12:48:56.976Z",
      countryCode: null,
      phoneNumber: null,
      college: null,
      graduationYear: null,
      degree: null,
      openToRelocate: null,
      gender: null,
      resume: null,
      socialMediaLinks: null,
      preferredProgrammingLanguage: null,
      candidateIndex: null,
      emailSentTime: "2024-12-24T11:34:21.478Z",
      assessmentLinkActiveDuration: null,
      emailFirstOpenedTime: null,
      status: "SHORTLISTED",
      rejectionReason: null,
      shouldAllowCompletingPreviousAssessment: null,
      attemptCount: null,
      finalCTC: null,
      assessmentUserId: "e3357ba0-0174-42c2-91e7-961ef0dc81c4",
      testAttemptId: "cad6bfa9-7a25-4a53-a7be-56014c5d368d",
      hashedTestAttemptId: "cad6bfa9-7a25-4a53-a7be-56014c5d368d",
      trustScore: 0.9896907,
      testEndReason: "SUBMIT",
      assessmentUserFeedback: "it was great",
      assessmentPdfLink:
        "https://acciomatrix.com/assessment-user-report/b6e8648e-e10c-4207-930b-78bc6485ca12",
      interviewCallIds: [],
      interviewStatus: null,
      assessmentUserRating: "5",
      ipAddress: "14.139.86.73",
      userId: "e3357ba0-0174-42c2-91e7-961ef0dc81c4",
      formFields: [
        {
          id: "5dc40603-51e7-499f-933b-7dabc4334674",
          type: "MOBILE",
          label: "Phone Number",
          value: "9680304392",
          values: null,
        },
        {
          id: "3f955fdd-e444-4bde-8e3c-9260841d2d38",
          type: "url",
          label: "Github",
          value: "https://github.com/mohdfazal",
          values: null,
        },
        {
          id: "b7134a66-770f-4de6-b257-249b149a08d3",
          type: "NUMBER",
          label: "How soon can you join",
          value: "15 days",
          values: null,
        },
        {
          id: "377cfd0f-fb13-4489-a682-abdf5768ad3f",
          type: "file",
          label: "Resume",
          value:
            "https://storage.googleapis.com/matrix-assessment-user/resume/e3357ba0-0174-42c2-91e7-961ef0dc81c4.pdf",
          values: null,
        },
        {
          id: "764703b4-9d8a-4af8-8013-5f309c396089",
          type: "SINGLE_SELECT",
          label:
            "This job requires Relocation to Pune will you be comfortable with that?",
          value: "1",
          values: null,
        },
      ],
      stage: "COMPLETED",
    },
    {
      id: "5de77359-7a44-436d-8801-65210428d902",
      email: "hozaifahanzala1111@gmail.com",
      hasSentEmail: true,
      createdAt: "2024-12-24 17:04:30",
      updatedAt: "2024-12-24T07:03:42.192Z",
      assessmentId: "4e42585f-80ef-4d4a-9b02-6cf41d5769fe",
      name: "Mohammad Hozaifa",
      totalQuestionsAsked: null,
      totalCorrectAnswers: null,
      totalWrongAnswers: null,
      totalUnattemptedQuestions: null,
      scorePercentage: "63",
      timeTakenByStudentInSeconds: null,
      feedback:
        "Candidate has an understanding of fundamental concepts but needs improvement in certain areas. The candidate showed good knowledge in implementing graph traversal techniques and handling binary trees using recursion. However, they struggled with SQL operations and password hashing implementations.",
      weakAreas: ["SQL", "Password Hashing", "Pseudo-code"],
      strongAreas: ["Graph Traversal", "Binary Trees", "Recursion"],
      gptFinalFeedback: null,
      assessmentStartedTime: "2024-12-24T11:37:29.977Z",
      assessmentCompletedTime: "2024-12-24T12:33:25.860Z",
      countryCode: null,
      phoneNumber: null,
      college: null,
      graduationYear: null,
      degree: null,
      openToRelocate: null,
      gender: null,
      resume: null,
      socialMediaLinks: null,
      preferredProgrammingLanguage: null,
      candidateIndex: null,
      emailSentTime: "2024-12-24T11:34:30.452Z",
      assessmentLinkActiveDuration: null,
      emailFirstOpenedTime: null,
      status: null,
      rejectionReason: null,
      shouldAllowCompletingPreviousAssessment: null,
      attemptCount: null,
      finalCTC: null,
      assessmentUserId: "80110168-6503-4bf3-bed6-f1c64aa89e0b",
      testAttemptId: "6b0d8def-adb7-4cd1-ab57-a4fbf2ba723d",
      hashedTestAttemptId: "6b0d8def-adb7-4cd1-ab57-a4fbf2ba723d",
      trustScore: 0.8041237,
      testEndReason: "SUBMIT",
      assessmentUserFeedback: null,
      assessmentPdfLink:
        "https://acciomatrix.com/assessment-user-report/5de77359-7a44-436d-8801-65210428d902",
      interviewCallIds: [],
      interviewStatus: null,
      assessmentUserRating: "5",
      ipAddress: "14.139.86.73",
      userId: "80110168-6503-4bf3-bed6-f1c64aa89e0b",
      formFields: [
        {
          id: "3f955fdd-e444-4bde-8e3c-9260841d2d38",
          type: "url",
          label: "Github",
          value: "https://github.com/csehozaifa",
          values: null,
        },
        {
          id: "5dc40603-51e7-499f-933b-7dabc4334674",
          type: "MOBILE",
          label: "Phone Number",
          value: "9044296929",
          values: null,
        },
        {
          id: "764703b4-9d8a-4af8-8013-5f309c396089",
          type: "SINGLE_SELECT",
          label:
            "This job requires Relocation to Pune will you be comfortable with that?",
          value: "1",
          values: null,
        },
        {
          id: "377cfd0f-fb13-4489-a682-abdf5768ad3f",
          type: "file",
          label: "Resume",
          value:
            "https://storage.googleapis.com/matrix-assessment-user/resume/80110168-6503-4bf3-bed6-f1c64aa89e0b.pdf",
          values: null,
        },
        {
          id: "b7134a66-770f-4de6-b257-249b149a08d3",
          type: "NUMBER",
          label: "How soon can you join",
          value: "15 days",
          values: null,
        },
      ],
      stage: "COMPLETED",
    },
    {
      id: "782c9df0-2caf-415f-93b3-8d609d877a3a",
      email: "wakku9780@gmail.com",
      hasSentEmail: true,
      createdAt: "2024-12-24 17:06:13",
      updatedAt: "2024-12-24T07:22:46.251Z",
      assessmentId: "4e42585f-80ef-4d4a-9b02-6cf41d5769fe",
      name: "Mohd Waqar Hashim",
      totalQuestionsAsked: null,
      totalCorrectAnswers: null,
      totalWrongAnswers: null,
      totalUnattemptedQuestions: null,
      scorePercentage: "50",
      timeTakenByStudentInSeconds: null,
      feedback:
        "The candidate has demonstrated a good understanding of basic programming concepts and problem-solving skills. They were able to handle some medium-level questions effectively, particularly in the area of graph traversal techniques. However, there are areas where they need improvement, such as SQL syntax correctness, attention to detail in coding tasks, and providing comprehensive explanations for theoretical concepts.",
      weakAreas: ["SQL", "attention to detail", "comprehensive explanation"],
      strongAreas: ["graph traversal", "problem-solving skills"],
      gptFinalFeedback: null,
      assessmentStartedTime: "2024-12-24T11:38:38.784Z",
      assessmentCompletedTime: "2024-12-24T12:52:36.797Z",
      countryCode: null,
      phoneNumber: null,
      college: null,
      graduationYear: null,
      degree: null,
      openToRelocate: null,
      gender: null,
      resume: null,
      socialMediaLinks: null,
      preferredProgrammingLanguage: null,
      candidateIndex: null,
      emailSentTime: "2024-12-24T11:36:13.509Z",
      assessmentLinkActiveDuration: null,
      emailFirstOpenedTime: null,
      status: null,
      rejectionReason: null,
      shouldAllowCompletingPreviousAssessment: null,
      attemptCount: null,
      finalCTC: null,
      assessmentUserId: "8fb691f9-01ec-44f1-b2a9-bec4ff93023f",
      testAttemptId: "10b37f6d-cb34-456b-b359-9af67d07146c",
      hashedTestAttemptId: "10b37f6d-cb34-456b-b359-9af67d07146c",
      trustScore: 0.9587629,
      testEndReason: "SUBMIT",
      assessmentUserFeedback: "nice",
      assessmentPdfLink:
        "https://acciomatrix.com/assessment-user-report/782c9df0-2caf-415f-93b3-8d609d877a3a",
      interviewCallIds: [],
      interviewStatus: null,
      assessmentUserRating: "4.5",
      ipAddress: "14.139.86.73",
      userId: "8fb691f9-01ec-44f1-b2a9-bec4ff93023f",
      formFields: [
        {
          id: "5dc40603-51e7-499f-933b-7dabc4334674",
          type: "MOBILE",
          label: "Phone Number",
          value: "9780290494",
          values: null,
        },
        {
          id: "3f955fdd-e444-4bde-8e3c-9260841d2d38",
          type: "url",
          label: "Github",
          value: "https://github.com/wakku9780",
          values: null,
        },
        {
          id: "b7134a66-770f-4de6-b257-249b149a08d3",
          type: "NUMBER",
          label: "How soon can you join",
          value: "15 days",
          values: null,
        },
        {
          id: "377cfd0f-fb13-4489-a682-abdf5768ad3f",
          type: "file",
          label: "Resume",
          value:
            "https://storage.googleapis.com/matrix-assessment-user/resume/8fb691f9-01ec-44f1-b2a9-bec4ff93023f.pdf",
          values: null,
        },
        {
          id: "764703b4-9d8a-4af8-8013-5f309c396089",
          type: "SINGLE_SELECT",
          label:
            "This job requires Relocation to Pune will you be comfortable with that?",
          value: "1",
          values: null,
        },
      ],
      stage: "COMPLETED",
    },
    {
      id: "c5f4f2d4-4d00-484a-a62c-9a3281af74ec",
      email: "prabhatkumar10200@gmail.com",
      hasSentEmail: true,
      createdAt: "2024-12-24 17:28:34",
      updatedAt: "2024-12-24T07:01:29.852Z",
      assessmentId: "4e42585f-80ef-4d4a-9b02-6cf41d5769fe",
      name: "Prabhat kumar jha",
      totalQuestionsAsked: null,
      totalCorrectAnswers: null,
      totalWrongAnswers: null,
      totalUnattemptedQuestions: null,
      scorePercentage: "42",
      timeTakenByStudentInSeconds: null,
      feedback:
        "The candidate performed decently overall. They demonstrated a good understanding of algorithmic concepts and problem-solving skills in the coding question involving ramp width. However, there were logical flaws in their SQL query for user engagement analysis, and they provided an irrelevant response to the Flask API question. Additionally, their abstract reasoning skills need improvement based on the ARC question result.",
      weakAreas: ["SQL", "Flask API implementation", "Abstract Reasoning"],
      strongAreas: ["Algorithmic concepts", "Problem-solving skills"],
      gptFinalFeedback: null,
      assessmentStartedTime: "2024-12-24T12:01:26.075Z",
      assessmentCompletedTime: "2024-12-24T12:30:58.316Z",
      countryCode: null,
      phoneNumber: null,
      college: null,
      graduationYear: null,
      degree: null,
      openToRelocate: null,
      gender: null,
      resume: null,
      socialMediaLinks: null,
      preferredProgrammingLanguage: null,
      candidateIndex: null,
      emailSentTime: "2024-12-24T11:58:34.007Z",
      assessmentLinkActiveDuration: null,
      emailFirstOpenedTime: null,
      status: null,
      rejectionReason: null,
      shouldAllowCompletingPreviousAssessment: null,
      attemptCount: null,
      finalCTC: null,
      assessmentUserId: "5da42734-33b9-4d9e-95ff-d39a366f5e0b",
      testAttemptId: "301790eb-ea9d-40c9-bbfa-e2a96ba2d84f",
      hashedTestAttemptId: "301790eb-ea9d-40c9-bbfa-e2a96ba2d84f",
      trustScore: 0.9896907,
      testEndReason: "SUBMIT",
      assessmentUserFeedback:
        "what is this type of like logic you are asking for ARC question in this test",
      assessmentPdfLink:
        "https://acciomatrix.com/assessment-user-report/c5f4f2d4-4d00-484a-a62c-9a3281af74ec",
      interviewCallIds: [],
      interviewStatus: null,
      assessmentUserRating: null,
      ipAddress: "45.115.255.12",
      userId: "5da42734-33b9-4d9e-95ff-d39a366f5e0b",
      formFields: [
        {
          id: "764703b4-9d8a-4af8-8013-5f309c396089",
          type: "SINGLE_SELECT",
          label:
            "This job requires Relocation to Pune will you be comfortable with that?",
          value: "1",
          values: null,
        },
        {
          id: "5dc40603-51e7-499f-933b-7dabc4334674",
          type: "MOBILE",
          label: "Phone Number",
          value: "9318364621",
          values: null,
        },
        {
          id: "3f955fdd-e444-4bde-8e3c-9260841d2d38",
          type: "url",
          label: "Github",
          value: "https://github.com/",
          values: null,
        },
        {
          id: "b7134a66-770f-4de6-b257-249b149a08d3",
          type: "NUMBER",
          label: "How soon can you join",
          value: "15 days",
          values: null,
        },
        {
          id: "377cfd0f-fb13-4489-a682-abdf5768ad3f",
          type: "file",
          label: "Resume",
          value:
            "https://storage.googleapis.com/matrix-assessment-user/resume/5da42734-33b9-4d9e-95ff-d39a366f5e0b.pdf",
          values: null,
        },
      ],
      stage: "COMPLETED",
    },
    {
      id: "8180d1a7-4cb3-4b3e-b10d-da9e91e8e96d",
      email: "jannatraj7569@gmail.com",
      hasSentEmail: true,
      createdAt: "2024-12-24 17:05:27",
      updatedAt: "2024-12-24T06:40:31.837Z",
      assessmentId: "4e42585f-80ef-4d4a-9b02-6cf41d5769fe",
      name: "Gautam Raj",
      totalQuestionsAsked: null,
      totalCorrectAnswers: null,
      totalWrongAnswers: null,
      totalUnattemptedQuestions: null,
      scorePercentage: "21",
      timeTakenByStudentInSeconds: null,
      feedback:
        "The candidate demonstrated a basic understanding of the topics but struggled with providing complete and correct solutions. The answers were often incomplete, had logical errors, or lacked sufficient depth. The candidate skipped multiple questions and failed to pass any test cases for the coding problem. Overall, there is a significant need for improvement in areas like coding implementation, debugging skills, and thoroughness in explanations.",
      weakAreas: [
        "Python",
        "Data Structures",
        "Flask",
        "Debugging Skills",
        "SQL",
      ],
      strongAreas: [],
      gptFinalFeedback: null,
      assessmentStartedTime: "2024-12-24T11:39:32.153Z",
      assessmentCompletedTime: "2024-12-24T12:10:29.449Z",
      countryCode: null,
      phoneNumber: null,
      college: null,
      graduationYear: null,
      degree: null,
      openToRelocate: null,
      gender: null,
      resume: null,
      socialMediaLinks: null,
      preferredProgrammingLanguage: null,
      candidateIndex: null,
      emailSentTime: "2024-12-24T11:35:27.348Z",
      assessmentLinkActiveDuration: null,
      emailFirstOpenedTime: null,
      status: null,
      rejectionReason: null,
      shouldAllowCompletingPreviousAssessment: null,
      attemptCount: null,
      finalCTC: null,
      assessmentUserId: "0f42ed4d-97ba-46ac-b8af-387d516d1b3e",
      testAttemptId: "21860d34-e6d9-4625-9803-76d9f437ae27",
      hashedTestAttemptId: "21860d34-e6d9-4625-9803-76d9f437ae27",
      trustScore: 1,
      testEndReason: "SUBMIT",
      assessmentUserFeedback: null,
      assessmentPdfLink:
        "https://acciomatrix.com/assessment-user-report/8180d1a7-4cb3-4b3e-b10d-da9e91e8e96d",
      interviewCallIds: [],
      interviewStatus: null,
      assessmentUserRating: "3",
      ipAddress: "103.211.13.154",
      userId: "0f42ed4d-97ba-46ac-b8af-387d516d1b3e",
      formFields: [
        {
          id: "5dc40603-51e7-499f-933b-7dabc4334674",
          type: "MOBILE",
          label: "Phone Number",
          value: "6202914630",
          values: null,
        },
        {
          id: "764703b4-9d8a-4af8-8013-5f309c396089",
          type: "SINGLE_SELECT",
          label:
            "This job requires Relocation to Pune will you be comfortable with that?",
          value: "1",
          values: null,
        },
        {
          id: "377cfd0f-fb13-4489-a682-abdf5768ad3f",
          type: "file",
          label: "Resume",
          value:
            "https://storage.googleapis.com/matrix-assessment-user/resume/0f42ed4d-97ba-46ac-b8af-387d516d1b3e.pdf",
          values: null,
        },
        {
          id: "b7134a66-770f-4de6-b257-249b149a08d3",
          type: "NUMBER",
          label: "How soon can you join",
          value: "15 days",
          values: null,
        },
        {
          id: "3f955fdd-e444-4bde-8e3c-9260841d2d38",
          type: "url",
          label: "Github",
          value: "https://github.com/Gauatm-raj",
          values: null,
        },
      ],
      stage: "COMPLETED",
    },
    {
      id: "84762d70-a83a-4935-beed-b7cfc6b589dd",
      email: "vshinde7887@gmail.com",
      hasSentEmail: true,
      createdAt: "2024-12-24 17:07:57",
      updatedAt: "2024-12-24T06:07:57.106Z",
      assessmentId: "4e42585f-80ef-4d4a-9b02-6cf41d5769fe",
      name: "vaibhav shinde",
      totalQuestionsAsked: null,
      totalCorrectAnswers: null,
      totalWrongAnswers: null,
      totalUnattemptedQuestions: null,
      scorePercentage: null,
      timeTakenByStudentInSeconds: null,
      feedback: null,
      weakAreas: null,
      strongAreas: null,
      gptFinalFeedback: null,
      assessmentStartedTime: null,
      assessmentCompletedTime: null,
      countryCode: null,
      phoneNumber: null,
      college: null,
      graduationYear: null,
      degree: null,
      openToRelocate: null,
      gender: null,
      resume: null,
      socialMediaLinks: null,
      preferredProgrammingLanguage: null,
      candidateIndex: null,
      emailSentTime: "2024-12-24T11:37:57.102Z",
      assessmentLinkActiveDuration: null,
      emailFirstOpenedTime: null,
      status: null,
      rejectionReason: null,
      shouldAllowCompletingPreviousAssessment: null,
      attemptCount: null,
      finalCTC: null,
      assessmentUserId: null,
      testAttemptId: null,
      hashedTestAttemptId: null,
      trustScore: null,
      testEndReason: null,
      assessmentUserFeedback: null,
      assessmentPdfLink: null,
      interviewCallIds: null,
      interviewStatus: null,
      assessmentUserRating: null,
      ipAddress: null,
      userId: "84762d70-a83a-4935-beed-b7cfc6b589dd",
      formFields: [
        {
          id: "5dc40603-51e7-499f-933b-7dabc4334674",
          type: "MOBILE",
          label: "Phone Number",
          value: "7887759537",
          values: null,
        },
        {
          id: "3f955fdd-e444-4bde-8e3c-9260841d2d38",
          type: "url",
          label: "Github",
          value: "https://github.com/vaibhavshinde7887",
          values: null,
        },
        {
          id: "b7134a66-770f-4de6-b257-249b149a08d3",
          type: "NUMBER",
          label: "How soon can you join",
          value: "15 days",
          values: null,
        },
        {
          id: "377cfd0f-fb13-4489-a682-abdf5768ad3f",
          type: "file",
          label: "Resume",
          value:
            "https://storage.googleapis.com/matrix-assessment-user/resume/84762d70-a83a-4935-beed-b7cfc6b589dd.pdf",
          values: null,
        },
        {
          id: "764703b4-9d8a-4af8-8013-5f309c396089",
          type: "SINGLE_SELECT",
          label:
            "This job requires Relocation to Pune will you be comfortable with that?",
          value: "1",
          values: null,
        },
      ],
      stage: "NOT_STARTED",
    },
  ],
  hasMoreResults: false,
};

export const candidatesData2 = {
  assessments: [
    {
      id: "b6e8648e-e10c-4207-930b-78bc6485ca12",
      email: "mf4357452@gmail.com",
      hasSentEmail: true,
      createdAt: "2024-12-24 17:04:21",
      updatedAt: "2024-12-24T07:19:15.253Z",
      assessmentId: "4e42585f-80ef-4d4a-9b02-6cf41d5769fe",
      name: "Aryan",
      totalQuestionsAsked: null,
      totalCorrectAnswers: null,
      totalWrongAnswers: null,
      totalUnattemptedQuestions: null,
      scorePercentage: "81",
      timeTakenByStudentInSeconds: null,
      feedback:
        "The candidate demonstrated a solid understanding of various technical concepts, particularly in solving algorithmic problems related to graphs and patterns using DFS and stack. The candidate also effectively solved an abstract reasoning question, showing strong logical thinking skills. However, there were issues with SQL syntax and handling Flask API character limit validation.",
      weakAreas: ["SQL", "Flask API"],
      strongAreas: ["Graphs", "DFS", "Stack", "Abstract Reasoning"],
      gptFinalFeedback: null,
      assessmentStartedTime: "2024-12-24T11:38:26.685Z",
      assessmentCompletedTime: "2024-12-24T12:48:56.976Z",
      countryCode: null,
      phoneNumber: null,
      college: null,
      graduationYear: null,
      degree: null,
      openToRelocate: null,
      gender: null,
      resume: null,
      socialMediaLinks: null,
      preferredProgrammingLanguage: null,
      candidateIndex: null,
      emailSentTime: "2024-12-24T11:34:21.478Z",
      assessmentLinkActiveDuration: null,
      emailFirstOpenedTime: null,
      status: null,
      rejectionReason: null,
      shouldAllowCompletingPreviousAssessment: null,
      attemptCount: null,
      finalCTC: null,
      assessmentUserId: "e3357ba0-0174-42c2-91e7-961ef0dc81c4",
      testAttemptId: "cad6bfa9-7a25-4a53-a7be-56014c5d368d",
      hashedTestAttemptId: "cad6bfa9-7a25-4a53-a7be-56014c5d368d",
      trustScore: 0.9896907,
      testEndReason: "SUBMIT",
      assessmentUserFeedback: "it was great",
      assessmentPdfLink:
        "https://acciomatrix.com/assessment-user-report/b6e8648e-e10c-4207-930b-78bc6485ca12",
      interviewCallIds: [],
      interviewStatus: null,
      assessmentUserRating: "5",
      ipAddress: "14.139.86.73",
      userId: "e3357ba0-0174-42c2-91e7-961ef0dc81c4",
      formFields: [
        {
          id: "5dc40603-51e7-499f-933b-7dabc4334674",
          type: "MOBILE",
          label: "Phone Number",
          value: "9680304392",
          values: null,
        },
        {
          id: "3f955fdd-e444-4bde-8e3c-9260841d2d38",
          type: "url",
          label: "Github",
          value: "https://github.com/mohdfazal",
          values: null,
        },
        {
          id: "b7134a66-770f-4de6-b257-249b149a08d3",
          type: "NUMBER",
          label: "How soon can you join",
          value: "15 days",
          values: null,
        },
        {
          id: "377cfd0f-fb13-4489-a682-abdf5768ad3f",
          type: "file",
          label: "Resume",
          value:
            "https://storage.googleapis.com/matrix-assessment-user/resume/e3357ba0-0174-42c2-91e7-961ef0dc81c4.pdf",
          values: null,
        },
        {
          id: "764703b4-9d8a-4af8-8013-5f309c396089",
          type: "SINGLE_SELECT",
          label:
            "This job requires Relocation to Pune will you be comfortable with that?",
          value: "1",
          values: null,
        },
      ],
      stage: "COMPLETED",
    },
    {
      id: "5de77359-7a44-436d-8801-65210428d902",
      email: "hozaifahanzala1111@gmail.com",
      hasSentEmail: true,
      createdAt: "2024-12-24 17:04:30",
      updatedAt: "2024-12-24T07:03:42.192Z",
      assessmentId: "4e42585f-80ef-4d4a-9b02-6cf41d5769fe",
      name: "Aryan",
      totalQuestionsAsked: null,
      totalCorrectAnswers: null,
      totalWrongAnswers: null,
      totalUnattemptedQuestions: null,
      scorePercentage: "63",
      timeTakenByStudentInSeconds: null,
      feedback:
        "Candidate has an understanding of fundamental concepts but needs improvement in certain areas. The candidate showed good knowledge in implementing graph traversal techniques and handling binary trees using recursion. However, they struggled with SQL operations and password hashing implementations.",
      weakAreas: ["SQL", "Password Hashing", "Pseudo-code"],
      strongAreas: ["Graph Traversal", "Binary Trees", "Recursion"],
      gptFinalFeedback: null,
      assessmentStartedTime: "2024-12-24T11:37:29.977Z",
      assessmentCompletedTime: "2024-12-24T12:33:25.860Z",
      countryCode: null,
      phoneNumber: null,
      college: null,
      graduationYear: null,
      degree: null,
      openToRelocate: null,
      gender: null,
      resume: null,
      socialMediaLinks: null,
      preferredProgrammingLanguage: null,
      candidateIndex: null,
      emailSentTime: "2024-12-24T11:34:30.452Z",
      assessmentLinkActiveDuration: null,
      emailFirstOpenedTime: null,
      status: null,
      rejectionReason: null,
      shouldAllowCompletingPreviousAssessment: null,
      attemptCount: null,
      finalCTC: null,
      assessmentUserId: "80110168-6503-4bf3-bed6-f1c64aa89e0b",
      testAttemptId: "6b0d8def-adb7-4cd1-ab57-a4fbf2ba723d",
      hashedTestAttemptId: "6b0d8def-adb7-4cd1-ab57-a4fbf2ba723d",
      trustScore: 0.8041237,
      testEndReason: "SUBMIT",
      assessmentUserFeedback: null,
      assessmentPdfLink:
        "https://acciomatrix.com/assessment-user-report/5de77359-7a44-436d-8801-65210428d902",
      interviewCallIds: [],
      interviewStatus: null,
      assessmentUserRating: "5",
      ipAddress: "14.139.86.73",
      userId: "80110168-6503-4bf3-bed6-f1c64aa89e0b",
      formFields: [
        {
          id: "3f955fdd-e444-4bde-8e3c-9260841d2d38",
          type: "url",
          label: "Github",
          value: "https://github.com/csehozaifa",
          values: null,
        },
        {
          id: "5dc40603-51e7-499f-933b-7dabc4334674",
          type: "MOBILE",
          label: "Phone Number",
          value: "9044296929",
          values: null,
        },
        {
          id: "764703b4-9d8a-4af8-8013-5f309c396089",
          type: "SINGLE_SELECT",
          label:
            "This job requires Relocation to Pune will you be comfortable with that?",
          value: "1",
          values: null,
        },
        {
          id: "377cfd0f-fb13-4489-a682-abdf5768ad3f",
          type: "file",
          label: "Resume",
          value:
            "https://storage.googleapis.com/matrix-assessment-user/resume/80110168-6503-4bf3-bed6-f1c64aa89e0b.pdf",
          values: null,
        },
        {
          id: "b7134a66-770f-4de6-b257-249b149a08d3",
          type: "NUMBER",
          label: "How soon can you join",
          value: "15 days",
          values: null,
        },
      ],
      stage: "COMPLETED",
    },
    {
      id: "782c9df0-2caf-415f-93b3-8d609d877a3a",
      email: "wakku9780@gmail.com",
      hasSentEmail: true,
      createdAt: "2024-12-24 17:06:13",
      updatedAt: "2024-12-24T07:22:46.251Z",
      assessmentId: "4e42585f-80ef-4d4a-9b02-6cf41d5769fe",
      name: "Aryan",
      totalQuestionsAsked: null,
      totalCorrectAnswers: null,
      totalWrongAnswers: null,
      totalUnattemptedQuestions: null,
      scorePercentage: "50",
      timeTakenByStudentInSeconds: null,
      feedback:
        "The candidate has demonstrated a good understanding of basic programming concepts and problem-solving skills. They were able to handle some medium-level questions effectively, particularly in the area of graph traversal techniques. However, there are areas where they need improvement, such as SQL syntax correctness, attention to detail in coding tasks, and providing comprehensive explanations for theoretical concepts.",
      weakAreas: ["SQL", "attention to detail", "comprehensive explanation"],
      strongAreas: ["graph traversal", "problem-solving skills"],
      gptFinalFeedback: null,
      assessmentStartedTime: "2024-12-24T11:38:38.784Z",
      assessmentCompletedTime: "2024-12-24T12:52:36.797Z",
      countryCode: null,
      phoneNumber: null,
      college: null,
      graduationYear: null,
      degree: null,
      openToRelocate: null,
      gender: null,
      resume: null,
      socialMediaLinks: null,
      preferredProgrammingLanguage: null,
      candidateIndex: null,
      emailSentTime: "2024-12-24T11:36:13.509Z",
      assessmentLinkActiveDuration: null,
      emailFirstOpenedTime: null,
      status: null,
      rejectionReason: null,
      shouldAllowCompletingPreviousAssessment: null,
      attemptCount: null,
      finalCTC: null,
      assessmentUserId: "8fb691f9-01ec-44f1-b2a9-bec4ff93023f",
      testAttemptId: "10b37f6d-cb34-456b-b359-9af67d07146c",
      hashedTestAttemptId: "10b37f6d-cb34-456b-b359-9af67d07146c",
      trustScore: 0.9587629,
      testEndReason: "SUBMIT",
      assessmentUserFeedback: "nice",
      assessmentPdfLink:
        "https://acciomatrix.com/assessment-user-report/782c9df0-2caf-415f-93b3-8d609d877a3a",
      interviewCallIds: [],
      interviewStatus: null,
      assessmentUserRating: "4.5",
      ipAddress: "14.139.86.73",
      userId: "8fb691f9-01ec-44f1-b2a9-bec4ff93023f",
      formFields: [
        {
          id: "5dc40603-51e7-499f-933b-7dabc4334674",
          type: "MOBILE",
          label: "Phone Number",
          value: "9780290494",
          values: null,
        },
        {
          id: "3f955fdd-e444-4bde-8e3c-9260841d2d38",
          type: "url",
          label: "Github",
          value: "https://github.com/wakku9780",
          values: null,
        },
        {
          id: "b7134a66-770f-4de6-b257-249b149a08d3",
          type: "NUMBER",
          label: "How soon can you join",
          value: "15 days",
          values: null,
        },
        {
          id: "377cfd0f-fb13-4489-a682-abdf5768ad3f",
          type: "file",
          label: "Resume",
          value:
            "https://storage.googleapis.com/matrix-assessment-user/resume/8fb691f9-01ec-44f1-b2a9-bec4ff93023f.pdf",
          values: null,
        },
        {
          id: "764703b4-9d8a-4af8-8013-5f309c396089",
          type: "SINGLE_SELECT",
          label:
            "This job requires Relocation to Pune will you be comfortable with that?",
          value: "1",
          values: null,
        },
      ],
      stage: "COMPLETED",
    },
    {
      id: "c5f4f2d4-4d00-484a-a62c-9a3281af74ec",
      email: "prabhatkumar10200@gmail.com",
      hasSentEmail: true,
      createdAt: "2024-12-24 17:28:34",
      updatedAt: "2024-12-24T07:01:29.852Z",
      assessmentId: "4e42585f-80ef-4d4a-9b02-6cf41d5769fe",
      name: "Prabhat kumar jha",
      totalQuestionsAsked: null,
      totalCorrectAnswers: null,
      totalWrongAnswers: null,
      totalUnattemptedQuestions: null,
      scorePercentage: "42",
      timeTakenByStudentInSeconds: null,
      feedback:
        "The candidate performed decently overall. They demonstrated a good understanding of algorithmic concepts and problem-solving skills in the coding question involving ramp width. However, there were logical flaws in their SQL query for user engagement analysis, and they provided an irrelevant response to the Flask API question. Additionally, their abstract reasoning skills need improvement based on the ARC question result.",
      weakAreas: ["SQL", "Flask API implementation", "Abstract Reasoning"],
      strongAreas: ["Algorithmic concepts", "Problem-solving skills"],
      gptFinalFeedback: null,
      assessmentStartedTime: "2024-12-24T12:01:26.075Z",
      assessmentCompletedTime: "2024-12-24T12:30:58.316Z",
      countryCode: null,
      phoneNumber: null,
      college: null,
      graduationYear: null,
      degree: null,
      openToRelocate: null,
      gender: null,
      resume: null,
      socialMediaLinks: null,
      preferredProgrammingLanguage: null,
      candidateIndex: null,
      emailSentTime: "2024-12-24T11:58:34.007Z",
      assessmentLinkActiveDuration: null,
      emailFirstOpenedTime: null,
      status: null,
      rejectionReason: null,
      shouldAllowCompletingPreviousAssessment: null,
      attemptCount: null,
      finalCTC: null,
      assessmentUserId: "5da42734-33b9-4d9e-95ff-d39a366f5e0b",
      testAttemptId: "301790eb-ea9d-40c9-bbfa-e2a96ba2d84f",
      hashedTestAttemptId: "301790eb-ea9d-40c9-bbfa-e2a96ba2d84f",
      trustScore: 0.9896907,
      testEndReason: "SUBMIT",
      assessmentUserFeedback:
        "what is this type of like logic you are asking for ARC question in this test",
      assessmentPdfLink:
        "https://acciomatrix.com/assessment-user-report/c5f4f2d4-4d00-484a-a62c-9a3281af74ec",
      interviewCallIds: [],
      interviewStatus: null,
      assessmentUserRating: null,
      ipAddress: "45.115.255.12",
      userId: "5da42734-33b9-4d9e-95ff-d39a366f5e0b",
      formFields: [
        {
          id: "764703b4-9d8a-4af8-8013-5f309c396089",
          type: "SINGLE_SELECT",
          label:
            "This job requires Relocation to Pune will you be comfortable with that?",
          value: "1",
          values: null,
        },
        {
          id: "5dc40603-51e7-499f-933b-7dabc4334674",
          type: "MOBILE",
          label: "Phone Number",
          value: "9318364621",
          values: null,
        },
        {
          id: "3f955fdd-e444-4bde-8e3c-9260841d2d38",
          type: "url",
          label: "Github",
          value: "https://github.com/",
          values: null,
        },
        {
          id: "b7134a66-770f-4de6-b257-249b149a08d3",
          type: "NUMBER",
          label: "How soon can you join",
          value: "15 days",
          values: null,
        },
        {
          id: "377cfd0f-fb13-4489-a682-abdf5768ad3f",
          type: "file",
          label: "Resume",
          value:
            "https://storage.googleapis.com/matrix-assessment-user/resume/5da42734-33b9-4d9e-95ff-d39a366f5e0b.pdf",
          values: null,
        },
      ],
      stage: "COMPLETED",
    },
    {
      id: "8180d1a7-4cb3-4b3e-b10d-da9e91e8e96d",
      email: "jannatraj7569@gmail.com",
      hasSentEmail: true,
      createdAt: "2024-12-24 17:05:27",
      updatedAt: "2024-12-24T06:40:31.837Z",
      assessmentId: "4e42585f-80ef-4d4a-9b02-6cf41d5769fe",
      name: "Gautam Raj",
      totalQuestionsAsked: null,
      totalCorrectAnswers: null,
      totalWrongAnswers: null,
      totalUnattemptedQuestions: null,
      scorePercentage: "21",
      timeTakenByStudentInSeconds: null,
      feedback:
        "The candidate demonstrated a basic understanding of the topics but struggled with providing complete and correct solutions. The answers were often incomplete, had logical errors, or lacked sufficient depth. The candidate skipped multiple questions and failed to pass any test cases for the coding problem. Overall, there is a significant need for improvement in areas like coding implementation, debugging skills, and thoroughness in explanations.",
      weakAreas: [
        "Python",
        "Data Structures",
        "Flask",
        "Debugging Skills",
        "SQL",
      ],
      strongAreas: [],
      gptFinalFeedback: null,
      assessmentStartedTime: "2024-12-24T11:39:32.153Z",
      assessmentCompletedTime: "2024-12-24T12:10:29.449Z",
      countryCode: null,
      phoneNumber: null,
      college: null,
      graduationYear: null,
      degree: null,
      openToRelocate: null,
      gender: null,
      resume: null,
      socialMediaLinks: null,
      preferredProgrammingLanguage: null,
      candidateIndex: null,
      emailSentTime: "2024-12-24T11:35:27.348Z",
      assessmentLinkActiveDuration: null,
      emailFirstOpenedTime: null,
      status: null,
      rejectionReason: null,
      shouldAllowCompletingPreviousAssessment: null,
      attemptCount: null,
      finalCTC: null,
      assessmentUserId: "0f42ed4d-97ba-46ac-b8af-387d516d1b3e",
      testAttemptId: "21860d34-e6d9-4625-9803-76d9f437ae27",
      hashedTestAttemptId: "21860d34-e6d9-4625-9803-76d9f437ae27",
      trustScore: 1,
      testEndReason: "SUBMIT",
      assessmentUserFeedback: null,
      assessmentPdfLink:
        "https://acciomatrix.com/assessment-user-report/8180d1a7-4cb3-4b3e-b10d-da9e91e8e96d",
      interviewCallIds: [],
      interviewStatus: null,
      assessmentUserRating: "3",
      ipAddress: "103.211.13.154",
      userId: "0f42ed4d-97ba-46ac-b8af-387d516d1b3e",
      formFields: [
        {
          id: "5dc40603-51e7-499f-933b-7dabc4334674",
          type: "MOBILE",
          label: "Phone Number",
          value: "6202914630",
          values: null,
        },
        {
          id: "764703b4-9d8a-4af8-8013-5f309c396089",
          type: "SINGLE_SELECT",
          label:
            "This job requires Relocation to Pune will you be comfortable with that?",
          value: "1",
          values: null,
        },
        {
          id: "377cfd0f-fb13-4489-a682-abdf5768ad3f",
          type: "file",
          label: "Resume",
          value:
            "https://storage.googleapis.com/matrix-assessment-user/resume/0f42ed4d-97ba-46ac-b8af-387d516d1b3e.pdf",
          values: null,
        },
        {
          id: "b7134a66-770f-4de6-b257-249b149a08d3",
          type: "NUMBER",
          label: "How soon can you join",
          value: "15 days",
          values: null,
        },
        {
          id: "3f955fdd-e444-4bde-8e3c-9260841d2d38",
          type: "url",
          label: "Github",
          value: "https://github.com/Gauatm-raj",
          values: null,
        },
      ],
      stage: "COMPLETED",
    },
    {
      id: "84762d70-a83a-4935-beed-b7cfc6b589dd",
      email: "vshinde7887@gmail.com",
      hasSentEmail: true,
      createdAt: "2024-12-24 17:07:57",
      updatedAt: "2024-12-24T06:07:57.106Z",
      assessmentId: "4e42585f-80ef-4d4a-9b02-6cf41d5769fe",
      name: "vaibhav shinde",
      totalQuestionsAsked: null,
      totalCorrectAnswers: null,
      totalWrongAnswers: null,
      totalUnattemptedQuestions: null,
      scorePercentage: null,
      timeTakenByStudentInSeconds: null,
      feedback: null,
      weakAreas: null,
      strongAreas: null,
      gptFinalFeedback: null,
      assessmentStartedTime: null,
      assessmentCompletedTime: null,
      countryCode: null,
      phoneNumber: null,
      college: null,
      graduationYear: null,
      degree: null,
      openToRelocate: null,
      gender: null,
      resume: null,
      socialMediaLinks: null,
      preferredProgrammingLanguage: null,
      candidateIndex: null,
      emailSentTime: "2024-12-24T11:37:57.102Z",
      assessmentLinkActiveDuration: null,
      emailFirstOpenedTime: null,
      status: null,
      rejectionReason: null,
      shouldAllowCompletingPreviousAssessment: null,
      attemptCount: null,
      finalCTC: null,
      assessmentUserId: null,
      testAttemptId: null,
      hashedTestAttemptId: null,
      trustScore: null,
      testEndReason: null,
      assessmentUserFeedback: null,
      assessmentPdfLink: null,
      interviewCallIds: null,
      interviewStatus: null,
      assessmentUserRating: null,
      ipAddress: null,
      userId: "84762d70-a83a-4935-beed-b7cfc6b589dd",
      formFields: [
        {
          id: "5dc40603-51e7-499f-933b-7dabc4334674",
          type: "MOBILE",
          label: "Phone Number",
          value: "7887759537",
          values: null,
        },
        {
          id: "3f955fdd-e444-4bde-8e3c-9260841d2d38",
          type: "url",
          label: "Github",
          value: "https://github.com/vaibhavshinde7887",
          values: null,
        },
        {
          id: "b7134a66-770f-4de6-b257-249b149a08d3",
          type: "NUMBER",
          label: "How soon can you join",
          value: "15 days",
          values: null,
        },
        {
          id: "377cfd0f-fb13-4489-a682-abdf5768ad3f",
          type: "file",
          label: "Resume",
          value:
            "https://storage.googleapis.com/matrix-assessment-user/resume/84762d70-a83a-4935-beed-b7cfc6b589dd.pdf",
          values: null,
        },
        {
          id: "764703b4-9d8a-4af8-8013-5f309c396089",
          type: "SINGLE_SELECT",
          label:
            "This job requires Relocation to Pune will you be comfortable with that?",
          value: "1",
          values: null,
        },
      ],
      stage: "NOT_STARTED",
    },
  ],
  hasMoreResults: false,
};

export const skills = [
  "SQL",
  "Flask API",
  "Password Hashing",
  "Pseudo-code",
  "attention to detail",
  "comprehensive explanation",
  "Flask API implementation",
  "Abstract Reasoning",
  "Python",
  "Data Structures",
  "Flask",
  "Debugging Skills",
  "Graphs",
  "DFS",
  "Stack",
  "Graph Traversal",
  "Binary Trees",
  "Recursion",
  "Algorithmic concepts",
  "Problem-solving skills",
];
